import CircuitBreaker from 'opossum';

type Params<P extends Parameters<any>, R> = {
    mainAction: (...args: P) => Promise<R>;
    fallbackAction: (...args: P) => Promise<R>;
    options?: {
        timeout?: number;
        errorThresholdPercentage?: number;
        resetTimeout?: number;
        rollingCountTimeout?: number;
        rollingCountBuckets?: number;
    };
};

export const circuitBreakerAction = <P extends unknown[], R>({
    mainAction,
    fallbackAction,
    options,
}: Params<P, R>): CircuitBreaker<P, R> => {
    const breaker = new CircuitBreaker(mainAction, {
        timeout: options?.timeout ?? 3000,
        errorThresholdPercentage: options?.errorThresholdPercentage ?? 50,
        resetTimeout: options?.resetTimeout ?? 30000,
        rollingCountTimeout: options?.rollingCountTimeout ?? 10000,
        rollingCountBuckets: options?.rollingCountBuckets ?? 10,
    });
    breaker.fallback(fallbackAction);

    return breaker;
};
